module.exports = __webpack_public_path__ + "images/line_friend_lp/step1-image_209656bae524356486d23791ac06cb52.png";